import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Partners from "./components/Partners";
import Certifications from "./components/Certifications";
import QuoteForm from "./components/QuoteForm";
import Footer from "./components/Footer";
import FallingLeaves from "./components/FallingLeaves";
import LoadingScreen from "./components/LoadingScreen";

function App() {
  return (
    <div className="App">
      <LoadingScreen />
      <FallingLeaves />
      <Toaster position="top-right" />
      <Header />
      <main>
        <Hero />
        <AboutUs />
        <Services />
        <Projects />
        <Partners />
        <Certifications />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
